// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7701":"cabe5102","8183":"4b540df0"}[chunkId] + ".chunk.css";
};